import { useFormikContext } from "formik";
import { MediaManager } from "@/components";
import OrganizationSetting from "./Setting";
import get from 'lodash/get';

interface Props {
    field: string;
    title: string;
    description: string;
}

const FileSetting = ({ field, title, description }: Props) => {
    const { values, setFieldValue } = useFormikContext<{
        logo: string;
        header: string;
    }>();

    return (
        <OrganizationSetting
            title={title}
            description={description}
        >
            <MediaManager
                value={get(values, field, '')}
                onChange={(values) => setFieldValue(field, values[0])}
            />
        </OrganizationSetting>
    )
}

export default FileSetting;
